import { GET_MANAGER_REVIEWS } from './actionTypes';

const actionGetManagerReviews = (payload) => ({
  payload,
  type: GET_MANAGER_REVIEWS,
});

export default actionGetManagerReviews;
